export const SECTION_WARNING_LINE =
  'Please note: we only accept businesses that have a trading (operating) address in the Kingdom or the Republic of Ireland.';
